import { forEach } from 'lodash';
const _waitTimers = [];
export default class Utils {
  // 処理待機関数
  static wait(duration) {
    return new Promise((resolve) => {
      _waitTimers.push(setTimeout(resolve, duration));
    });
  }
  static clearWait() {
    forEach(_waitTimers, (timer) => clearTimeout(timer));
    _waitTimers.length = 0;
  }
  // jsonファイルを探査し、ロード対象の画像ファイルを収集し配列で返却する
  static getImageFiles(images, required = false) {
    let src = [];
    src = images
      .map((lists) => {
        // model
        const model = lists.model;
        return lists.items
          .map((category) => {
            // UNIT, CABINET画像のロード
            if (category.colors) {
              return category.colors.map((item) => ({
                model: model,
                code: item.code,
                ...(required &&
                  item.file && {
                    file: require(`@/assets/image/${model}/${category.parts}/${item.file}`),
                  }),
                parts: item.parts
                  ? item.parts.map((part) =>
                      required
                        ? {
                            type: part.type,
                            file: require(`@/assets/image/${model}/${part.type}/${part.file}`),
                          }
                        : part
                    )
                  : [],
                name: item.name,
                type: category.parts,
              }));
            }
            // SEAT画像のロード
            if (category.sub_category) {
              return category.sub_category
                .map((element) => {
                  return element.colors.map((item) => ({
                    model: model,
                    code: item.code,
                    file: required
                      ? require(`@/assets/image/${model}/${category.parts}/${item.file}`)
                      : item.file,
                    name: item.name,
                    type: category.parts,
                  }));
                })
                .flat();
            }
          })
          .flat();
      })
      .flat();
    return src;
  }
}
